<template>
  <div class="modal-card" style="600px">
    <div class="modal-card-head">
      <p class="modal-card-title">Template {{ beamName }}</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </div>
    <div class="modal-card-body">
      <b-input
          type="textarea"
          rows="20"
          v-model="template" 
          readonly/>
    </div>
    <footer class="modal-card-foot">
      <b-button @click="$emit('close')">Close</b-button>
    </footer>
  </div>
</template>
<script setup>
import { defineProps, ref, getCurrentInstance, onMounted } from 'vue';
import { useAdminNetworkStore } from '../../admin/stores/admin-network-store';

const props = defineProps(['nmsType', 'antennaType', 'modemType', 'beamName']);
const template = ref('Loading...');
const templateLoading = ref(false);
const store = useAdminNetworkStore();
const app = getCurrentInstance();

const loadTemplate = async () => {
  templateLoading.value = true;
  if (props.nmsType && props.antennaType && props.modemType && props.beamName) {
    const network = {
      nmsType: props.nmsType,
      antennaType: props.antennaType,
      modemType: props.modemType,
      beamDisplayName: props.beamName
    };
    const result = await store.dispatch('getTemplate', network);
    if (!result.isSuccess) {
      if (result.error != 'The specified template does not exist.') {
        app.proxy.$buefy.toast.open({
          duration: 3000,
          message: result.error || 'Error encountered while attempting to load Template.',
          type: 'is-danger'
        });
      }
      template.value = result.error;
    } else template.value = result.data;
  }
  templateLoading.value = false;
}

onMounted(async () => {
  await loadTemplate();
})
</script>
